import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, StandardDonation } from '@domains';
import { Deserialize } from 'cerialize';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class StandardDonationsService extends BaseApiService<StandardDonation> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'standard_donations', StandardDonation, 'StandardDonation', ['charity'], ['charity']);
  }

  override deserialize(data: any): StandardDonation {
    const result = new StandardDonation(Deserialize(data, StandardDonation));
    result.items?.forEach((item) => {
      if (item.photo_url && !item.photo_url.startsWith('http')) {
        item.photo_url = this.config.urls.baseUrl + item.photo_url;
      }
      if (item.icon_url && !item.icon_url.startsWith('http')) {
        item.icon_url = this.config.urls.baseUrl + item.icon_url;
      }
    });
    if (result.charity?.logo && !result.charity.logo.startsWith('http')) {
      result.charity.logo = this.config.urls.baseUrl + result.charity.logo;
    }
    result.setInitialValue();
    return result;
  }
}
